'use strict';

module.exports = Object.freeze({
  enumerable: true,
  configurable: true,
  writable: true,
  value: void 0
});


//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/options/propertyOptions.js
// module id = 458
// module chunks = 0